import {baseUrl} from "./config";

export const getCoinById = async (coinId: string) => {
    return fetch(`${baseUrl}/coins/${coinId}?localization=false&tickers=false&developer_data=false`);
}

export const getMarkets = async (ids: string) => {
    return fetch(`${baseUrl}/coins/markets?vs_currency=usd&ids=${ids || ""}`);
}